import { CONSENT_CATEGORIES, hasConsent } from 'src/functions/consent/oneTrustConsent';

type RouteLocation = { pathname: string } | null | undefined;

/**
 * Pushes a page view for a client-side navigation to the GTM dataLayer, with
 * the title, location, path and referrer that GA otherwise reports as unset
 * on SPA navigations. GTM replays the whole dataLayer when it loads, so the
 * push waits for the Targeting consent GTM itself is gated on; otherwise
 * pre-consent page views would be sent after acceptance.
 */
export const pushRouteUpdate = (location: RouteLocation, prevLocation: RouteLocation): void => {
  if (typeof window === 'undefined' || !window.dataLayer) return;
  if (!hasConsent(CONSENT_CATEGORIES.targeting)) return;

  const pageData = {
    event: 'gatsby_route_update',
    page_title: document.title,
    page_location: window.location.href,
    page_path: location ? location.pathname : window.location.pathname,
    page_referrer: prevLocation ? `${window.location.origin}${prevLocation.pathname}` : document.referrer,
  };
  window.dataLayer.push(pageData);
};
